import React from "react";
import Icon from "../../_default/Icon";
import Spinner from "../../_default/Spinner";
import ReactPlayer from "react-player";

export default function AddFilesForSending(props) {
  return (
    <div className="c-chat-progress-wrapper">
      {props.uploadProgress.length > 0 &&
        props.uploadProgress.map((item, idx) => (
          <div className="c-upload-content-wrapper">
            {typeof item === "object" && !props.fileDeleting.some((e) => e === item.url) && !props.uploadProgress.some((e) => typeof e === "number") && (
              <div className="c-remove-icon" onClick={() => props.deleteFile(item.url, idx)}>
                <Icon icon="trash" stroke="#fff" size={14} height={14} />
              </div>
            )}
            <div className="c-upload-content" style={typeof item !== "number" && item && item.type.split("/")[0] === "video" ? { backgroundColor: "#000" } : { backgroundImage: `url("${item ? item.url : ""}")` }}>
              {typeof item !== "number" && item && item.type.split("/")[0] === "video" && <ReactPlayer url={item.url} loop={true} volume={0} width="100%" muted={true} playing={true} style={{ position: "relative", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />}
              {typeof item === "number" && (
                <>
                  <div className="c-progress" style={{ width: item + "%" }} />
                  <span>{parseInt(item)}%</span>
                </>
              )}
              {item && props.fileDeleting.some((e) => e === item.url) && (
                <>
                  <div className="c-file-deleting"> </div>
                  <Spinner />
                </>
              )}
              {item && item.type === "application/pdf" && (
                <>
                  <p className="c-file-name">{item.name}</p>
                  <Icon icon="pdf" stroke="#fff" size={20} height={20} />
                </>
              )}
              {item && item.type === "application/zip" && (
                <>
                  <p className="c-file-name">{item.name}</p>
                  <Icon icon="zip" stroke="#fff" size={20} height={20} />
                </>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}
